import React from 'react';
import Layout from "../components/Layout";
import NavTwo from "../components/NavTwo";
import SliderTwo from "../components/SliderTwo";
import LandingArea from "../components/LandingArea";
import FooterArea from "../components/FooterLanding";

const LandingPage = () => {
    return (
        <div className='landingpage'>
            <Layout pageTitle="Ouderslokaal">
                <NavTwo />
                <SliderTwo />
                <LandingArea />
                <FooterArea />
            </Layout>
        </div>
    );
};

export default LandingPage;
